import { defineNuxtPlugin } from '@nuxtjs/composition-api'
import Vue from 'vue'
import vueVimeoPlayer from 'vue-vimeo-player'

export default defineNuxtPlugin(() => {
  Vue.use(vueVimeoPlayer)
})
